import { MCPTool } from '../types';
import { firecrawlService } from '../../services/firecrawlService';
import { geminiService } from '../../services/geminiService';
import { getMCPServer } from '../server/MCPServer';

/**
 * Scrapes a website to extract content, markdown, and metadata.
 */
export const scrapeWebsiteTool: MCPTool = {
  name: 'scrape_website',
  description: 'Scrapes a website URL to extract REAL content, markdown, and metadata. Use this to analyze specific business websites or landing pages.',
  
  inputSchema: {
    type: 'object',
    properties: {
      url: {
        type: 'string',
        description: 'The URL to scrape (must be a valid HTTP/HTTPS URL)'
      }
    },
    required: ['url']
  },

  async execute(params) {
    try {
      const result = await firecrawlService.scrapeWebsite(params.url);
      return {
        success: true,
        data: result,
        message: `Successfully scraped ${params.url}`
      };
    } catch (error: any) {
      return {
        success: false,
        error: `Scraping failed: ${error.message}`
      };
    }
  }
};

/**
 * Searches Google for information.
 */
export const googleSearchTool: MCPTool = {
  name: 'google_search',
  description: 'Searches Google for information. Use this to find company URLs, news, or general industry data.',
  
  inputSchema: {
    type: 'object',
    properties: {
      query: {
        type: 'string',
        description: 'The search query'
      }
    },
    required: ['query']
  },

  async execute(params) {
    try {
      const result = await geminiService.generateWithGemini(
        `Search Google for: "${params.query}" and provide a summary of the top results with URLs.`,
        { tools: [{ googleSearch: {} }] }
      );
      return {
        success: true,
        results: result,
        message: `Search results for "${params.query}"`
      };
    } catch (error: any) {
      return {
        success: false,
        error: `Search failed: ${error.message}`
      };
    }
  }
};

export function registerResearchTools(): void {
  const server = getMCPServer();
  
  server.registerTool(scrapeWebsiteTool, {
    category: 'research',
    requiresAuth: true,
    dangerLevel: 'safe'
  });
  
  server.registerTool(googleSearchTool, {
    category: 'research',
    requiresAuth: true,
    dangerLevel: 'safe'
  });
  
  console.log('✅ Registered 2 research tools');
}

